import React from 'react';
import PropTypes from 'prop-types';

import './keynote.scss';

const Keynote = ({
  children, title, image, watch,
}) => (
  <div className="keynote">
    <h1 className="keynote__header">
      {title}
    </h1>
    <div className="keynote__content">
      <div className="keynote__img">
        <img src={image} alt="Hack the North's keynote speaker" />
        <div className="keynote__gear keynote__gear--red">
          <img src="/images/keynote-red-gear.png" alt="" />
        </div>
        <div className="keynote__gear keynote__gear--blue">
          <img src="/images/keynote-blue-gear.png" alt="" />
        </div>
        <div className="keynote__gear keynote__gear--green">
          <img src="/images/keynote-green-gear.png" alt="" />
        </div>
        <div className="keynote__gear keynote__gear--yellow">
          <img src="/images/keynote-yellow-gear.png" alt="" />
        </div>
      </div>
      <div className="keynote__body">
        {children}
        <a href="https://www.youtube.com/watch?v=nHHCrTjclN4" target="_blank" rel="noopener noreferrer"><button className="keynote__watch">{watch}</button></a>
      </div>
    </div>
  </div>
);

Keynote.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  watch: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default Keynote;



// WEBPACK FOOTER //
// ./src/components/Judges/Keynote/index.jsx